import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/final-exam/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/final-exam',
  name: 'activity_final_exam',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '祈福集卡 逢考必胜',
  },
}

export default [indexRoute]
